import { render } from "./PCAccessories.vue?vue&type=template&id=3405f40a"
import script from "./PCAccessories.vue?vue&type=script&lang=js"
export * from "./PCAccessories.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__